module.exports = __webpack_public_path__ + "static/media/partner06.ab3798d9.svg";